import produce from 'immer';
import { types, IPaymentInitialState, IGetPublishableKeyResponse } from './types';
import { types as AuthTypes } from '../authentication/types';
import { IGenericDocumentModifier } from '../../types/global/helper';

const initialState: IPaymentInitialState = {
    loading: false,
    paymentMethods: [],
    isNonUs: true,
};

const reducer = (state = initialState, action: any) => {
    const { type, payload } = action;
    switch (type) {
        case types.ADD_PAYMENT_METHOD:
        case types.UPDATE_PAYMENT_METHOD:
        case types.GET_PAYMENT_METHODS:
        case types.DELETE_PAYMENT_METHOD:
        case types.GET_PUBLISHABLE_KEY:
            return produce(state, draft => {
                draft.loading = true;
            });
        case types.ADD_PAYMENT_METHOD_FAIL:
        case types.DELETE_PAYMENT_METHOD_FAIL:
        case types.GET_PAYMENT_METHODS_FAIL:
        case types.UPDATE_PAYMENT_METHOD_FAIL:
        case types.GET_PUBLISHABLE_KEY_FAIL:
            return produce(state, draft => {
                draft.loading = false;
                draft.errMsg = payload;
            });
        case types.DELETE_PAYMENT_METHOD_SUCCESS:
            return produce(state, draft => {
                const { documentId } = payload as IGenericDocumentModifier;
                draft.loading = false;
                draft.paymentMethods = draft.paymentMethods?.filter(cards => cards._id !== documentId);
            });
        case types.UPDATE_PAYMENT_METHOD_SUCCESS:
            return produce(state, draft => {
                draft.loading = false;
                draft.errMsg = payload;
                draft.paymentMethods = draft.paymentMethods?.filter(cards => cards._id !== payload._id);
            });
        case types.GET_PAYMENT_METHODS_SUCCESS:
            return produce(state, draft => {
                draft.loading = false;
                draft.paymentMethods = payload;
            });
        case types.ADD_PAYMENT_METHOD_SUCCESS:
            return produce(state, draft => {
                draft.loading = false;
                draft.paymentMethods?.unshift(payload);
            });
        case types.CREATE_PAYMENT_INTENT_FOR_PURCHASE:
        case types.CREATE_PAYMENT_INTENT:
            return produce(state, draft => {
                draft.loading = true;
                draft.paymentIntentToken = undefined;
            });
        case types.CREATE_PAYMENT_INTENT_SUCCESS:
        case types.CREATE_PAYMENT_INTENT_FOR_PURCHASE_SUCCESS:
            return produce(state, draft => {
                draft.loading = false;
                draft.paymentIntentToken = payload;
            });
        case types.CREATE_PAYMENT_INTENT_FAIL:
        case types.CREATE_PAYMENT_INTENT_FOR_PURCHASE_FAIL:
            return produce(state, draft => {
                draft.loading = false;
                draft.paymentIntentToken = undefined;
            });
        case types.GET_PUBLISHABLE_KEY_SUCCESS:
            return produce(state, draft => {
                const { isNonUs, publishableKey, provider } = payload as IGetPublishableKeyResponse;
                const source = provider ?? 'stripe';
                draft.loading = false;
                draft.isNonUs = isNonUs;
                if (publishableKey) {
                    if (!draft.publishableKeys) draft.publishableKeys = {};
                    draft.publishableKeys[source] = publishableKey;

                    // Stripe keys fetched by always-mounted checkout/payment modals must not
                    // clobber the active Paystack/Flutterwave key used by billing CTAs.
                    const active = draft.publishableKeySource;
                    const stripeBackgroundFetch = source === 'stripe' && active && active !== 'stripe';
                    if (!stripeBackgroundFetch) {
                        draft.publishableKey = publishableKey;
                        draft.publishableKeySource = source;
                    }
                }
            });
        case AuthTypes.LOGOUT:
            return produce(state, draft => {
                draft.paymentMethods = [];
                draft.loading = false;
                draft.publishableKey = undefined;
                draft.publishableKeySource = undefined;
                draft.publishableKeys = undefined;
            });
        default:
            return state;
    }
};

export { reducer };
